export default __webpack_public_path__ + "static/media/paper_tur.3e8a399f.pdf";